import Vue from 'vue'
import "@babel/polyfill";
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

//import Amplify from 'aws-amplify'
import { Amplify } from "aws-amplify";
import aws_exports from './aws-exports'
import { components } from 'aws-amplify-vue' 

import VueHead from 'vue-head'
import VueMoment from 'vue-moment'

import VueCookies from 'vue-cookies'
import {
  applyPolyfills,
  defineCustomElements,
} from "@aws-amplify/ui-components/loader";

Vue.use(VueHead)
Vue.use(VueMoment)
Vue.use(VueCookies)

Vue.config.productionTip = false

Amplify.configure(aws_exports)
applyPolyfills().then(() => {
  defineCustomElements(window);
});


new Vue({
  router,
  components: { 
    App,
    ...components
  },
  store,
  vuetify,
  render: h => h(App),
  created: () => (document.documentElement.setAttribute('lang', 'ja')),
}).$mount('#app')
